<p-fileUpload #uploader
              [customUpload]="true"
              [multiple]="true"
              [auto]="true"
              [showCancelButton]="false"
              [disabled]="disabled"
              [chooseIcon]="uploader.uploading ? 'pi pi-spin pi-spinner' : 'pi pi-plus'"
              [chooseLabel]="uploader.uploading ? 'Uploading' : 'Choose'"
              [maxFileSize]="maxFileSize"
              (uploadHandler)="handleUpload($event)"
              pDroppable
              (onDrop)="onDrop($event)">

    <ng-template pTemplate="file" let-file></ng-template>

    <ng-template pTemplate="content">
        <div class="drop-container" *ngIf="!uploader.uploading && !disabled">
            <div class="p-py-2 p-text-center">
                Drop Files Here
                <p-divider *ngIf="hasFiles"></p-divider>
            </div>
        </div>

        <div *ngIf="uploader.files.length || hasFiles" class="content">
            <ng-container *ngIf="uploader.files.length">
                <p-divider align="center">
                    <b>Uploading</b>
                </p-divider>
            </ng-container>

            <p-table *ngIf="uploader.files.length" [value]="uploader.files">
                <ng-template pTemplate="body" let-fa>
                    <tr>
                        <td>{{fa.name}}</td>

                        <td class="p-text-right">
                            <p-button styleClass="p-button-danger"
                                      icon="pi pi-times"
                                      (click)="cancelUpload(fa)">
                            </p-button>
                        </td>
                    </tr>
                </ng-template>
            </p-table>

            <ng-container *ngIf="uploader.files.length && hasFiles">
                <p-divider align="center">
                    <b>Completed</b>
                </p-divider>
            </ng-container>

            <p-table *ngIf="hasFiles" [value]="files">
                <ng-template pTemplate="body" let-fa>
                    <tr *ngIf="fa.description != 'Rich Text Image'">
                        <td>
                            <lb-file-detail-listing [file]="fa" [siblings]="files"></lb-file-detail-listing>
                        </td>

                        <td class="p-text-right">
                            <p-button (onClick)="removeFile(fa)"
                                      label="Remove"
                                      icon="pi pi-trash"
                                      styleClass="p-button-danger">
                            </p-button>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </ng-template>
</p-fileUpload>